import { Component, ElementRef, QueryList, ViewChildren } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { NgbActiveModal, NgbDateParserFormatter, NgbDateStruct, NgbDatepickerI18n, NgbTimeStruct, NgbTimepicker } from '@ng-bootstrap/ng-bootstrap';
import { Config } from 'app/config.const';
import { IAppuntamento, RispostaAppuntamento } from 'app/model/appuntamento';
import { Contatti } from 'app/model/contatti';
import { CustomDateParserFormatter, CustomDatepickerI18n } from 'app/model/datepicker';
import { ImpostazioniGenerali } from 'app/model/impostazioni_generali';
import { Pazienti } from 'app/model/pazienti';
import { ISubject } from 'app/model/soggetto';
import * as Fuse from 'fuse.js';
import * as moment from 'moment';
import { Observable } from 'rxjs/Observable';
import { combineLatest, debounceTime, map } from 'rxjs/operators';
import { isString } from 'util';

@Component({
	selector: 'app-newevent',
	templateUrl: './newEvent.html',
	styleUrls: ['./newEvent.css'],
	providers: [
		{ provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n },
		{ provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter }
	] // define custom provider
})
export class NewEventComponent {
	// BAU!
	//       __
	//  (___()'`;
	//  /,    /`
	//  \\"--\\
	@ViewChildren(NgbTimepicker, { read: ElementRef })
	set picker(value: QueryList<ElementRef>) {
		// Diciamo grazie ai tizi di bootstrap.
		for (let el of value.map(c => c.nativeElement as HTMLElement)) {
			let list = el.querySelectorAll(".btn-link");
			for (var i = 0; i < list.length; i++) {
				(list.item(i) as HTMLElement).tabIndex = -1;
			}
		}
	}

	domande = []
	risposte: RispostaAppuntamento[] = []
	risposteSolaLettura = false

	hideTime = false;
	date: NgbDateStruct = null;
	inizio: NgbTimeStruct = { hour: 0, minute: 0, second: 0 };
	fine: NgbTimeStruct = { hour: 0, minute: 0, second: 0 };
	event: IAppuntamento;
	show = false;
	formGroup = new FormGroup({
		categoria: new FormControl(),
		soggetto: new FormControl(),
		citta: new FormControl(),
		indirizzo: new FormControl(),
		numciv: new FormControl(),
		pr: new FormControl(),
		cap: new FormControl()
	});

	constructor(
		public activeModal: NgbActiveModal,
		public impostazioni: ImpostazioniGenerali,
		private contatti: Contatti,
		private pazienti: Pazienti
	) {
		moment.locale('it');

		const domande = localStorage.getItem('agenda.domande-medico')
		if (domande) {
			this.domande = JSON.parse(domande)
		}
	}

	get newEvent(): boolean {
		if (this.event.evento == null && this.event.categoria == null) {
			this.event.categoria = "Paziente";
			this.event.evento = "Visita ambulatoriale";
		}
		return this.event && +this.event.id < 0;
	}

	initRisposte() {
		return this.domande.map(d => { return { domanda: d.testo, risposta: '' } })
	}

	isWeekend(date: NgbDateStruct) {
		return moment({
			year: date.year,
			month: date.month - 1,
			day: date.day
		}).weekday() > 4;
	}

	setEvento(event: IAppuntamento) {
		this.event = event;
		const i: moment.Moment = moment.utc(event.start);

		this.date = {
			year: i.get('year'),
			month: i.get('month') + 1,
			day: i.get('date')
		};

		if (!event.end) {
			this.hideTime = true;
		} else {
			const f: moment.Moment = moment.utc(event.end);
			this.inizio = { hour: i.get('hour'), minute: i.get('minute'), second: i.get('second') };
			this.fine = { hour: f.get('hour'), minute: f.get('minute'), second: f.get('second') };
		}

		if (parseInt(event.id) > 0) {
			this.risposte = event.risposte
			this.risposteSolaLettura = true
		} else {
			this.risposte = this.initRisposte()
		}

	}

	setCategoria(evento: string) {
		this.event.evento = evento;

		// FIXME: Che cazzo è questo?
		let cat = (function () {
			return $(':selected', this).closest('optgroup').attr('label');
		})();

		if (cat) {
			this.event.categoria = cat;
		}
	}

	setAllDay() {
		if (this.hideTime) {
			this.event.end = null;
		}
	}

	format() {
		if (!this.hideTime) {
			const i: moment.Moment = moment.utc({
				day: this.date.day,
				month: this.date.month - 1, // La scomodità
				year: this.date.year,
				hour: this.inizio.hour,
				minute: this.inizio.minute,
				second: this.inizio.second
			});
			const f: moment.Moment = moment.utc({
				day: this.date.day,
				month: this.date.month - 1, // La scomodità
				year: this.date.year,
				hour: this.fine.hour,
				minute: this.fine.minute,
				second: this.fine.second
			});
			this.event.start = i;
			this.event.end = f;
		} else {
			const i: moment.Moment = moment.utc({
				day: this.date.day,
				month: this.date.month - 1, // La scomodità
				year: this.date.year
			});
			this.event.start = i;
		}
	}

	check() {
		return (this.inizio.hour < this.fine.hour) ||
			(
				(this.inizio.hour === this.fine.hour) &&
				(this.inizio.minute < this.fine.minute)
			);
	}

	checkDomande() {
		if (this.risposte) {
			for (let i = 0; i < this.risposte.length; i++) {
				if (!this.risposte[i]['risposta'] || this.risposte[i]['risposta'].replace(' ', '').length === 0) {
					return false
				}
			}
		}
		return true
	}

	valid() {
		return this.formGroup.valid && this.checkDomande() &&
			this.event.evento && this.event.categoria &&
			(this.event.start || this.date) &&
			(this.check() || this.hideTime);
	}

	upsert() {
		this.format();
		this.activeModal.close({
			id: this.event.id,
			title: this.event.title,
			start: this.event.start,
			end: this.event.end,
			indirizzo: this.event.indirizzo,
			numciv: this.event.numciv,
			citta: this.event.citta,
			CAP: this.event.CAP,
			provincia: this.event.provincia,
			descrizione: this.event.descrizione,
			categoria: this.event.categoria,
			evento: this.event.evento,
			version: +this.event.version + 1,
			status: this.event.status,
			risposte: this.risposte
		});
	}

	cancella() {
		this.activeModal.close({
			delete: true,
			id: +this.event.id,
			end: this.event.end
		});
	}

	toggleShow() {
		this.show = !this.show;
	}

	contactSearch = (terms$: Observable<string>) => {
		return terms$.pipe(
			debounceTime(Config.searchDebounceTime),
			combineLatest(this.contatti.pipe(
				map(contatti => new Fuse(
					contatti,
					Object.assign({
						keys: ["cognome", "nome", "titolo"],
						minMatchCharLength: 2
					}, Config.fuse)
				))
			)),
			map(([term, contacts]) => contacts.search(term))
		);
	}

	pazientiSearch = (terms$: Observable<string>) => {
		return terms$.pipe(
			debounceTime(Config.searchDebounceTime),
			combineLatest(this.pazienti.pipe(
				map(contatti => new Fuse(
					contatti,
					Object.assign({
						keys: ["cognome", "nome", "titolo"],
						minMatchCharLength: 2
					}, Config.fuse)
				))
			)),
			map(([term, contacts]) => contacts.search(term))
		);
	}

	contactFormat(result: ISubject) {
		if (isString(result)) {
			return result;
		} else {
			return `${result.cognome} ${result.nome}`;
		}
	}

	fillInFromSubject = (subject: string | ISubject) => {
		// questa chiamata deve limitarsi ad impostare il valore del titolo senza la logica di
		// gestione del medico
		this.event.title = subject as string;

		/*if (isString(subject)) {
			this.event.title = subject as string;
		} else {
			const contatto = subject as ISubject;
			this.show = true;

			if (contatto.medico) {
				this.event.title = `${contatto.cognome} ${contatto.nome} - Dr. ${contatto.medico}`;
			} else {
				this.event.title = `${contatto.cognome} ${contatto.nome}`;
			}

			this.event.citta = contatto.citta;
			this.event.indirizzo = contatto.indirizzo;
			this.event.numciv = contatto.numciv;
			this.event.provincia = contatto.pr;
			this.event.CAP = contatto.cap;
		}*/
	}
}



// WEBPACK FOOTER //
// ./src/app/calendar/newEvent/newEvent.ts